"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6884],{

/***/ 26884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_GetToKnow; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
;// CONCATENATED MODULE: ./components/sections/GetToKnow/getToKnow.styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 3rem;\n    line-height: 3.5rem;\n    letter-spacing: -0.0125rem;\n    margin-bottom: 3rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}



const Section = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "e1wclt0c0"
})("background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.light_grey;
}, ";");
const Inner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1wclt0c1"
})("display:flex;flex-direction:column;", mixins/* defaultContainerSize */.sX, ";padding-top:4rem;padding-bottom:5rem;");
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h3", {
    target: "e1wclt0c2"
})("font-weight:400;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";font-size:2rem;line-height:2.5rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";margin:0 0 1.5rem 0;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), ";");
const Stages = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1wclt0c3"
})("display:none;flex-direction:row;overflow-x:scroll;gap:1.875rem;padding-bottom:0.5rem;align-items:flex-start;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())), ";::-webkit-scrollbar{height:6px;}/* Track */::-webkit-scrollbar-track{background:transparent;}/* Handle */::-webkit-scrollbar-thumb{background:#888;}/* Handle on hover */::-webkit-scrollbar-thumb:hover{background:#555;}");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/sections/GetToKnow/getToKnow.hooks.tsx

const useGetToKnowHooks = ()=>{
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const onButtonClick = ()=>{
        setIsOpen((prevState)=>!prevState);
    };
    const childRef = (0,react.useRef)(null);
    return {
        isOpen,
        onButtonClick,
        childRef
    };
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
;// CONCATENATED MODULE: ./components/sections/GetToKnow/Stage/stage.styles.tsx

function stage_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      min-height: auto;\n      max-height: 100%;\n    "
    ]);
    stage_styles_templateObject = function() {
        return data;
    };
    return data;
}
function stage_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-width: 23.4375rem;\n  "
    ]);
    stage_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-width: 29.375rem;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-height: 729px;\n    max-height: 729px;\n    margin: 0 0 0.5rem 0;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-width: 29.375rem;\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 2rem;\n    line-height: 2.5rem;\n    margin-bottom: 1.5rem;\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-height: 40rem;\n    "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 1.5rem;\n    max-height: unset;\n  "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-height: 13.25rem;\n    max-width: 15.5rem;\n    justify-self:center;\n  "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 20rem;\n    max-height: unset;\n  "
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-self:unset;\n    max-height: unset;\n    max-width: unset;\n  "
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-height: 13.25rem;\n      max-width: 15.5rem;\n    "
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-width: 20rem;\n      max-height: unset;\n    "
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-height: unset;\n      max-width: unset;\n    "
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}



const StageWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e11zt23h0"
})("box-sizing:border-box;user-select:none;display:grid;grid-template-columns:1fr;grid-template-rows:auto 1fr;padding:1.5rem;width:100%;min-width:18rem;max-width:296px;margin:0 auto 0.5rem auto;box-shadow:0 4.0354px 4.0354px rgba(0,0,0,0.25);border-radius:1rem;min-height:612px;max-height:612px;justify-content:space-between;transition:min-height,max-height 0.25s ease-in-out;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";", (param)=>{
    let { isOpen  } = param;
    return isOpen && (0,emotion_react_browser_esm/* css */.iv)(stage_styles_templateObject());
}, " ", mixins.mq.smallIp((0,emotion_react_browser_esm/* css */.iv)(stage_styles_templateObject1())), ";", mixins.mq.small((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), ";", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())), ";", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject4())), ";");
const TextWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e11zt23h1"
})("display:flex;flex-direction:column;");
const Button = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e11zt23h2"
})("background-color:transparent;border:none;box-shadow:none;font-size:1rem;line-height:1.5rem;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.nunito;
}, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, ";letter-spacing:0.0125rem;align-self:flex-start;margin-bottom:1rem;");
const StageTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e11zt23h3"
})("font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";font-size:1.5rem;line-height:2rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";font-weight:400;margin:0 0 1rem 0;text-align:left;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject5())), ";");
const StageDescription = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e11zt23h4"
})("margin:0 0 1rem 0;font-size:1rem;line-height:2rem;letter-spacing:0.0125rem;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.nunito;
}, ";font-weight:300;text-align:left;max-height:18rem;white-space:pre-line;overflow:hidden;text-overflow:ellipsis;transition:max-height 0.25s ease-in-out;", (param)=>{
    let { isOpen  } = param;
    return isOpen && (0,emotion_react_browser_esm/* css */.iv)(_templateObject6());
}, " ", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject7())), ";");
const StageImageWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e11zt23h5"
})("display:flex;justify-self:center;align-self:flex-end;border-radius:1rem;max-height:13.25rem;", mixins.mq.smallIp((0,emotion_react_browser_esm/* css */.iv)(_templateObject8())), ";", mixins.mq.small((0,emotion_react_browser_esm/* css */.iv)(_templateObject9())), ";", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject10())), ";img{border-radius:1rem;max-height:13.25rem;-webkit-user-drag:none;-khtml-user-drag:none;-moz-user-drag:none;-o-user-drag:none;user-drag:none;", mixins.mq.smallIp((0,emotion_react_browser_esm/* css */.iv)(_templateObject11())), ";", mixins.mq.small((0,emotion_react_browser_esm/* css */.iv)(_templateObject12())), ";", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject13())), ";}");

// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(21977);
;// CONCATENATED MODULE: ./components/sections/GetToKnow/Stage/Stage.tsx






const Stage = (param)=>{
    let { meet_us_image , meet_us_title , meet_us_description , isOpen , onClick  } = param;
    const { width  } = (0,useWindowSize/* useWindowSize */.i)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StageWrapper, {
        isOpen: !!isOpen,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TextWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StageTitle, {
                        children: prismic_reactjs.RichText.asText(meet_us_title)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StageDescription, {
                        isOpen: !!isOpen,
                        children: prismic_reactjs.RichText.asText(meet_us_description)
                    }),
                    prismic_reactjs.RichText.asText(meet_us_description).length > 380 && width && width < 515 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button, {
                        onClick: onClick,
                        children: !isOpen ? "Rozwiń" : "Zwiń"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StageImageWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                    ...(0,imageSerializer/* imageSerializer */.l)(meet_us_image)
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/index.mjs
var es_value = __webpack_require__(33234);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/MotionConfigContext.mjs
var MotionConfigContext = __webpack_require__(16014);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(96681);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/use-motion-value.mjs





/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */
function useMotionValue(initial) {
    const value = (0,use_constant/* useConstant */.h)(() => (0,es_value/* motionValue */.B)(initial));
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */
    const { isStatic } = (0,react.useContext)(MotionConfigContext/* MotionConfigContext */._);
    if (isStatic) {
        const [, setLatest] = (0,react.useState)(initial);
        (0,react.useEffect)(() => value.on("change", setLatest), []);
    }
    return value;
}



;// CONCATENATED MODULE: ./components/core/CarouselFramer/DragSlider/dragSlider.hooks.tsx


const useDragSlider = (childRef, children)=>{
    const ref = (0,react.useRef)(null);
    const x = useMotionValue(0);
    const [visibleSliderWidth, setVisibleSliderWidth] = (0,react.useState)(0);
    const [singleSlideWidth, setSingleSlideWidth] = (0,react.useState)(0);
    const [trueSliderWidth, setTrueSliderWidthh] = (0,react.useState)(0);
    const [sliderConstraints, setSliderConstraints] = (0,react.useState)(0);
    // get current widths 
    const calcSliderWidth = (0,react.useCallback)(()=>{
        var _ref_current, _ref_current1, _childRef_current;
        if (ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.clientWidth) {
            var _ref_current2;
            setVisibleSliderWidth(ref === null || ref === void 0 ? void 0 : (_ref_current2 = ref.current) === null || _ref_current2 === void 0 ? void 0 : _ref_current2.clientWidth);
        }
        if (ref === null || ref === void 0 ? void 0 : (_ref_current1 = ref.current) === null || _ref_current1 === void 0 ? void 0 : _ref_current1.scrollWidth) {
            var _ref_current3;
            setTrueSliderWidthh(ref === null || ref === void 0 ? void 0 : (_ref_current3 = ref.current) === null || _ref_current3 === void 0 ? void 0 : _ref_current3.scrollWidth);
        }
        if (childRef === null || childRef === void 0 ? void 0 : (_childRef_current = childRef.current) === null || _childRef_current === void 0 ? void 0 : _childRef_current.offsetWidth) {
            var _childRef_current1;
            setSingleSlideWidth(childRef === null || childRef === void 0 ? void 0 : (_childRef_current1 = childRef.current) === null || _childRef_current1 === void 0 ? void 0 : _childRef_current1.offsetWidth);
        }
    }, [
        ref,
        childRef
    ]);
    // constraints is calculated by
    // the full width needed to fit all children in overlay:hidden
    // minus width of visible slider
    const calcSliderConstraints = (0,react.useCallback)(()=>{
        setSliderConstraints(trueSliderWidth - visibleSliderWidth);
    }, [
        trueSliderWidth,
        visibleSliderWidth
    ]);
    // set for the 1st time widths, and cleanup in the end
    (0,react.useEffect)(()=>{
        window.addEventListener("resize", calcSliderWidth);
        window.addEventListener("resize", calcSliderConstraints);
        return ()=>{
            window.removeEventListener("resize", calcSliderWidth);
            window.removeEventListener("resize", calcSliderConstraints);
        };
    }, []);
    // set new width if any window or element changes size
    (0,react.useEffect)(()=>{
        calcSliderWidth();
        window.addEventListener("resize", calcSliderWidth);
        calcSliderConstraints();
        window.addEventListener("resize", calcSliderConstraints);
    }, [
        ref,
        trueSliderWidth,
        visibleSliderWidth,
        childRef
    ]);
    const childrenCount = (0,react.useMemo)(()=>{
        return react.Children.count(children) - 1;
    }, [
        children
    ]);
    return {
        ref,
        x,
        sliderConstraints,
        visibleSliderWidth,
        singleSlideWidth,
        trueSliderWidth,
        childrenCount
    };
};

;// CONCATENATED MODULE: ./components/core/CarouselFramer/DragSlider/Slider/slider.hooks.tsx

const useSlider = (param)=>{
    let { singleSlideWidth , visibleSliderWidth , margin , activeSlide , childrenCount , sliderConstraints , trueSliderWidth , x , setActiveSlide  } = param;
    const remToPxValue = (0,react.useMemo)(()=>{
        return margin * 16;
    }, [
        margin
    ]);
    // returns calculated shift for just for 2nd element
    // calculate how much width of 1st element is hidden to center 2nd element
    // that value is used to inifital shift
    const offsetFirstElement = (0,react.useMemo)(()=>{
        return singleSlideWidth - (visibleSliderWidth - (singleSlideWidth + 2 * remToPxValue)) / 2;
    }, [
        singleSlideWidth,
        visibleSliderWidth,
        margin
    ]);
    // set value for animation property
    // for first active slide, shifts max to left - set to 0
    // for last active slide shift max to right - set to -sliderConstraints
    // for others, use just once offsetFirstElement to center second element
    // and add multiplied values of gap+slideWidth to center each next element
    const outputRadio = (0,react.useMemo)(()=>{
        if (activeSlide === 0) {
            return 0;
        } else if (activeSlide >= childrenCount) {
            return -sliderConstraints;
        } else {
            return -offsetFirstElement - (activeSlide - 1) * (singleSlideWidth + remToPxValue);
        }
    }, [
        activeSlide,
        childrenCount,
        sliderConstraints,
        singleSlideWidth,
        margin
    ]);
    // on dragging change dynamically active indicator under Slider
    // amount is equally divided by full slider width and amount of children
    // just in case check if childrenCount is not -1, to not divide by 0
    const onDrag = (0,react.useCallback)(()=>{
        let amount = 1;
        if (childrenCount !== -1) {
            amount = trueSliderWidth / (childrenCount + 1);
        }
        if (x.get() < -sliderConstraints + remToPxValue * 2) {
            setActiveSlide(childrenCount);
            return;
        }
        setActiveSlide(Math.abs(Math.floor(x.get() / amount)));
    }, [
        trueSliderWidth,
        childrenCount,
        sliderConstraints,
        margin,
        childrenCount
    ]);
    // similar to onDrag, but sometimes elements are shifting after dragging
    // after 3 seconds calculate current X and check current position
    const onDragEnd = (0,react.useCallback)(()=>{
        let amount = 1;
        if (childrenCount !== -1) {
            amount = trueSliderWidth / (childrenCount + 1);
        }
        setTimeout(()=>{
            if (x.get() < -sliderConstraints + remToPxValue * 2) {
                setActiveSlide(childrenCount);
                return;
            }
            setActiveSlide(Math.abs(Math.floor(x.get() / amount)));
        }, 3000);
    }, [
        trueSliderWidth,
        childrenCount,
        sliderConstraints,
        margin,
        childrenCount
    ]);
    return {
        outputRadio,
        onDrag,
        onDragEnd
    };
};

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 194 modules
var motion = __webpack_require__(96121);
;// CONCATENATED MODULE: ./components/core/CarouselFramer/DragSlider/Slider/slider.styles.tsx


const SliderMotion = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(motion/* motion.div */.E.div, {
    shouldForwardProp: (propName)=>!propName.startsWith("$"),
    target: "e1kzzgc30"
})("cursor:grab;display:flex;flex-direction:row;user-select:none;gap:", (param)=>{
    let { $gapSize  } = param;
    return $gapSize ? "".concat($gapSize, "rem") : "1rem";
}, ";");
const SliderWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1kzzgc31"
})("overflow-x:hidden;");

;// CONCATENATED MODULE: ./components/core/CarouselFramer/DragSlider/Slider/Slider.tsx



const Slider = (param)=>{
    let { children , sliderRef , x , sliderConstraints , bounceStiffness , bounceDamping , visibleSliderWidth , singleSlideWidth , setActiveSlide , trueSliderWidth , activeSlide , childrenCount , margin  } = param;
    const { outputRadio , onDrag , onDragEnd  } = useSlider({
        singleSlideWidth,
        visibleSliderWidth,
        margin,
        activeSlide,
        childrenCount,
        sliderConstraints,
        trueSliderWidth,
        x,
        setActiveSlide
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SliderWrapper, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SliderMotion, {
            $gapSize: margin,
            ref: sliderRef,
            drag: "x",
            initial: {
                x: 0
            },
            style: {
                x
            },
            dragConstraints: {
                left: -sliderConstraints,
                right: 0
            },
            dragTransition: {
                bounceStiffness,
                bounceDamping
            },
            animate: {
                x: outputRadio
            },
            transition: {
                bounceStiffness,
                bounceDamping
            },
            onDrag: onDrag,
            onDragEnd: onDragEnd,
            children: children
        })
    });
};


;// CONCATENATED MODULE: ./components/core/CarouselFramer/DragSlider/DragSlider.tsx



const DragSlider = (param)=>{
    let { children , bounceStiffness , bounceDamping , childRef , activeSlide , setActiveSlide , margin  } = param;
    const { ref , x , sliderConstraints , visibleSliderWidth , singleSlideWidth , trueSliderWidth , childrenCount  } = useDragSlider(childRef, children);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Slider, {
        sliderRef: ref,
        x: x,
        sliderConstraints: sliderConstraints,
        bounceStiffness: bounceStiffness,
        bounceDamping: bounceDamping,
        visibleSliderWidth: visibleSliderWidth,
        singleSlideWidth: singleSlideWidth,
        setActiveSlide: setActiveSlide,
        trueSliderWidth: trueSliderWidth,
        activeSlide: activeSlide,
        childrenCount: childrenCount,
        margin: margin,
        children: children
    });
};


;// CONCATENATED MODULE: ./components/core/CarouselFramer/DragSlider/index.tsx

/* harmony default export */ var CarouselFramer_DragSlider = (DragSlider);

// EXTERNAL MODULE: ./components/indicator/index.ts + 2 modules
var indicator = __webpack_require__(81049);
;// CONCATENATED MODULE: ./components/core/CarouselFramer/carouselFramer.hooks.tsx

const useCarouselFramer = ()=>{
    const [activeSlide, setActiveSlide] = (0,react.useState)(0);
    return {
        activeSlide,
        setActiveSlide
    };
};

;// CONCATENATED MODULE: ./components/core/CarouselFramer/carouselFramer.styles.tsx

function carouselFramer_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n  "
    ]);
    carouselFramer_styles_templateObject = function() {
        return data;
    };
    return data;
}



const CarouselContainer = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("div", {
    target: "e1q9a4q40"
})("display:flex;overflow:hidden;user-select:none;")));
const IndicatorsList = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", {
    target: "e1q9a4q41"
})("list-style-type:none;display:none;align-items:center;justify-content:center;", mixins.mq.smallIp((0,emotion_react_browser_esm/* css */.iv)(carouselFramer_styles_templateObject())), ";");

;// CONCATENATED MODULE: ./components/core/CarouselFramer/CarouselFramer.tsx






const CarouselFramer = (param)=>{
    let { children , margin , childRef , bounceStiffness =100 , bounceDamping =5  } = param;
    const { activeSlide , setActiveSlide  } = useCarouselFramer();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselFramer_DragSlider, {
                childRef: childRef,
                activeSlide: activeSlide,
                setActiveSlide: setActiveSlide,
                margin: margin,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                children: children
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IndicatorsList, {
                children: react.Children.map(children, (child, i)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(indicator/* default */.Z, {
                        onClickHandler: ()=>setActiveSlide(i),
                        isSelected: activeSlide === i,
                        index: i,
                        label: i.toString()
                    }))
            })
        ]
    });
};


;// CONCATENATED MODULE: ./components/core/CarouselFramer/index.tsx

/* harmony default export */ var core_CarouselFramer = (CarouselFramer);

;// CONCATENATED MODULE: ./components/sections/GetToKnow/GetToKnow.tsx





const GetToKnow = (param)=>{
    let { titleAs , title , items  } = param;
    const { isOpen , onButtonClick , childRef  } = useGetToKnowHooks();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Inner, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                    as: titleAs,
                    children: title
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core_CarouselFramer, {
                    margin: 2,
                    childRef: childRef,
                    children: items.map((item, index)=>{
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            ref: childRef,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Stage, {
                                ...item,
                                isOpen: isOpen,
                                onClick: onButtonClick
                            })
                        }, index);
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/sections/GetToKnow/index.ts

/* harmony default export */ var sections_GetToKnow = (GetToKnow);


/***/ })

}]);